export default {
  value: false,
  color: null,
  message: null
};
